import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FiLogIn } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const LoginPage = () => {
  const [form, setForm] = useState({ phone: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.phone || !form.password) {
      setError(t('auth.fill_fields'));
      return;
    }

    setLoading(true);
    setError('');

    try {
      await login(form.phone, form.password);
      navigate('/admin');
    } catch (err) {
      const message = err.response?.data?.message || t('auth.invalid_credentials');
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-header">
          <Link to="/" className="navbar-logo" style={{ justifyContent: 'center', marginBottom: 20 }}>
            <img src="/logo.png" alt="UzSport" style={{ height: 40, width: 'auto' }} />
            <span>UzSport</span>
          </Link>
          <h1>{t('auth.login_title')}</h1>
          <p>{t('auth.login_subtitle')}</p>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          {error && <div className="auth-error">{error}</div>}

          <div className="form-group">
            <label htmlFor="phone">{t('auth.phone')}</label>
            <input
              id="phone"
              className="form-input"
              type="text"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="+998 90 123 45 67"
              autoComplete="tel"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">{t('auth.password')}</label>
            <input
              id="password"
              className="form-input"
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              placeholder="••••••••"
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-lg"
            style={{ width: '100%', marginTop: 8 }}
            disabled={loading}
          >
            {loading ? t('auth.signing_in') : <><FiLogIn /> {t('auth.sign_in')}</>}
          </button>
        </form>

        <div className="auth-footer">
          <Link to="/">{t('auth.back_home')}</Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
